import React, { Fragment, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Dropdown } from "semantic-ui-react";
import { BasicContext } from "../../App";
import { postMethod } from "../../requests";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCheck, faUserSlash } from "@fortawesome/free-solid-svg-icons";
import { faCircleQuestion } from "@fortawesome/free-regular-svg-icons";

const StudentAttendancesDropdown = (props) => {
    const { onChange, value, id, disabled } = props;
    const { t } = useTranslation();
    const { checkServerData } = useContext(BasicContext);
    const [list, setList] = useState(null);
    const [loading, setLoading] = useState(true);

    const text = (e) => {
        return (
            <>
                <FontAwesomeIcon
                    icon={e.ua_status_code === "PRESENT" ? faUserCheck : e.ua_status_code === "ABSENT" ? faUserSlash : faCircleQuestion}
                    className={`me-2 ${e.ua_status_code === "PRESENT" ? "text-success" : e.ua_status_code === "ABSENT" ? "text-danger" : "text-secondary"}`}
                />
                {t(`attendanceCodes.${e.ua_status_code}`)}
            </>
        );
    };

    const getAttendanceList = async () => {
        const res = await postMethod("/get-attendance-list");
        if (checkServerData(res)) {
            const list = [],
                users = res.data.list;
            users.forEach((e, i) => {
                list.push({
                    key: i,
                    value: e.ua_status_code,
                    text: text(e),
                    content: text(e),
                });
            });
            setList(list);
        }
    };

    useEffect(() => {
        if (list) setLoading(false);
        // eslint-disable-next-line
    }, [list]);

    useEffect(() => {
        getAttendanceList();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            {loading ? (
                <p>{t("loadingData")}</p>
            ) : (
                <Dropdown
                    placeholder={t("chooseOrSearch")}
                    fluid
                    selection
                    options={list}
                    onChange={(e, data) => onChange(data.value)}
                    value={value}
                    id={id}
                    disabled={disabled}
                    noResultsMessage={t("noResultsFound")}
                />
            )}
        </Fragment>
    );
};

export default StudentAttendancesDropdown;
